<div class="w-full space-y-4">

  <!-- Page Header -->
  <div class="flex items-center justify-between pb-4 border-b border-slate-200">
    <div class="flex items-center gap-3">
      <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-slate-600">straighten</mat-icon>
      </div>
      <div>
        <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
          Unit Master
        </h2>
        <p class="text-xs text-slate-500 font-medium mt-0.5">
          Manage units of measurement
        </p>
      </div>
    </div>
  </div>

  <!-- ================= FORM SECTION ================= -->
  <div class="bg-white rounded-lg shadow-sm border border-slate-300 px-4 py-4">
    <form class="flex flex-col md:flex-row md:items-center gap-4">
      
      <!-- Unit Name -->
      <mat-form-field appearance="outline" class="w-full md:w-1/3">
        <mat-label>Unit Name</mat-label>
        <mat-icon matPrefix class="text-slate-500 mr-4">scale</mat-icon>
        <input matInput [(ngModel)]="unitName" name="unitName" required placeholder="Enter unit name">
      </mat-form-field>

      <!-- Is Active -->
      <div class="flex items-center h-auto md:h-[56px] w-full md:w-auto">
        <mat-checkbox [(ngModel)]="isActive" name="isActive">
          <span class="text-xs font-semibold tracking-widest uppercase text-slate-700">
            Active
          </span>
        </mat-checkbox>
      </div>

      <!-- Buttons -->
      <div class="flex items-center justify-end w-full md:w-auto gap-3 shrink-0 md:ml-auto">
        <button type="button" (click)="lFN_Reset()" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
          Reset
        </button>
        <button type="button" (click)="lFN_Save()" class="px-6 py-2 rounded-md
                 bg-gradient-to-r from-slate-900 to-black
                 text-white text-[12px] font-medium tracking-widest uppercase
                 shadow hover:from-black hover:to-slate-800
                 transition-all duration-150 whitespace-nowrap">
          {{ unitId ? 'Update' : 'Save' }}
        </button>
      </div>

    </form>
  </div>

  <!-- ================= TABLE SECTION ================= -->
  <div class="bg-white rounded-lg shadow-sm border border-slate-300 overflow-x-auto">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">

      <!-- SRNO -->
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white text-xs uppercase text-center w-[10%] px-4">Sr No.</th>
        <td mat-cell *matCellDef="let row; let i = index" class="text-center text-sm px-4">{{ i + 1 }}</td>
      </ng-container>

      <!-- Unit Name -->
      <ng-container matColumnDef="unitName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="bg-gray-900 text-white text-xs uppercase text-left w-[50%] px-4">Unit Name</th>
        <td mat-cell *matCellDef="let row" class="text-sm px-4">{{ row.unitName }}</td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white text-xs uppercase text-center w-[20%] px-4">Status</th>
        <td mat-cell *matCellDef="let row" class="text-center px-4">
          <span class="inline-block w-20 text-center px-0 py-1.5 rounded-full text-[10px] font-semibold tracking-widest uppercase transition-all duration-200 border cursor-pointer hover:shadow-md" 
            (click)="lFN_ToggleUnitStatus(row)"
            matTooltip="Click to change status"
            [ngClass]="row.unitIsActive === 'YES' ? 'bg-emerald-200 text-emerald-900 border-emerald-600' : 'bg-rose-200 text-rose-900 border-rose-600'">
            {{ row.unitIsActive === 'YES' ? 'Active' : 'Inactive' }}
          </span>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white text-xs uppercase text-center w-[20%] px-4">Actions</th>
        <td mat-cell *matCellDef="let row" class="text-center px-4">
          <button mat-icon-button (click)="lFN_Edit(row)" matTooltip="Edit"><mat-icon class="text-slate-600 text-sm">edit</mat-icon></button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
